import { addressFormFieldsSX } from '@/components/blocks/AddressForm/styles/fields';
import { DpButton } from '@/components/blocks/DpLibrary/DpButton';
import { DpOutlinedInput } from '@/components/blocks/OutlinedInput';
import { PasswordInput } from '@/components/blocks/PasswordInput';
import { REG_EX } from '@/utils/address';
import { Stack } from '@mui/material';

type Props = {
	logonId: string;
	logonIdError?: string;
	password: string;
	passwordError?: string;
	disabled?: boolean;
	onChangeLogonId: (logonId: string) => void;
	onBlurLogonId: () => void;
	onChangePassword: (password: string) => void;
	onSubmitLogin: () => void;
	onToggleSelectOtpMethod: () => void;
};

export const LoginPasswordStage: React.FC<Props> = ({
	logonId,
	logonIdError,
	password,
	passwordError,
	disabled,
	onChangeLogonId,
	onBlurLogonId,
	onChangePassword,
	onSubmitLogin,
	onToggleSelectOtpMethod,
}) => (
	<Stack width="100%">
		<DpOutlinedInput
			sx={{
				...addressFormFieldsSX,
				'.MuiOutlinedInput-input': {
					padding: '14px 14px',
					fontSize: 'var(--font-size-body)',
					height: '20px',
				},
				marginBottom: '20px',
			}}
			variant="outlined"
			fullWidth
			required
			name="email"
			autoComplete="email"
			id="email-sign-in-submit"
			label="Correo electrónico"
			error={!!logonIdError}
			helperText={logonIdError}
			value={logonId}
			InputLabelProps={{
				sx: {
					fontSize: 'var(--font-size-body)',
					lineHeight: '1',
				},
			}}
			inputProps={{
				maxLength: 100,
				type: 'email',
				pattern: REG_EX.EMAIL.source,
			}}
			FormHelperTextProps={{
				sx: { ml: '3px' },
			}}
			onChange={(e) => onChangeLogonId(e.target.value)}
			onBlur={onBlurLogonId}
		/>
		<PasswordInput
			sx={addressFormFieldsSX}
			required
			name="logonPassword"
			label="Contraseña"
			value={password}
			inputProps={{
				maxLength: 40,
				pattern: REG_EX.PASSWORD.source,
			}}
			onBlur={onSubmitLogin}
			error={!!passwordError}
			helperText={passwordError}
			onChange={(e) => onChangePassword(e.target.value)}
		/>

		<DpButton
			sx={{ mt: '20px', width: '100%', maxWidth: '400px', alignSelf: 'center' }}
			id="button-login-password-submit"
			disabled={disabled}
			onClick={onSubmitLogin}
		>
			{'Iniciar sesión'}
		</DpButton>

		<DpButton sx={{ mt: '20px' }} variant="text" onClick={onToggleSelectOtpMethod}>
			{'Iniciar sesión sin contraseña'}
		</DpButton>
	</Stack>
);
